import { useFormikContext } from 'formik';
import { MessageFormValues } from './types';

export function useMessageForm() {
  return useFormikContext<MessageFormValues>();
}
